module.exports = __webpack_public_path__ + "static/007-508bea7d9ce7013da9c78d42fb4c2cfd.jpg";